module.exports = __webpack_public_path__ + "static/media/sent_plane.5f3b62e2.svg";